// @ts-nocheck
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from '../../router-compat';
import { inject, observer } from "../../stores/mobx-compat";
import qs from 'query-string';

import useLoginStore from '../../stores/loginStore';
import AuthShell from './AuthShell';
import {
  Field, PrimaryButton, TermsModal,
  MailIcon, LockIcon, UserIcon, PhoneIcon, BuildingIcon, GlobeIcon,
} from '../../components/ui';

const submitHubSpot = (data) => {
  const body = Object.entries(data)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  fetch('https://forms.hubspot.com/uploads/form/v2/4595743/2f4d76ba-f873-4350-997c-a0693db2f47d', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
    body,
  });
};

const RegisterPage = ({ store, location }) => {
  const {
    email, password, passwordConfirm, fullName, phone, websiteUrl, company,
    tosChecked, loading, error,
    setField, setLoading, setError, toggleTos,
  } = useLoginStore();
  const [tosOpen, setTosOpen] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== passwordConfirm) return setError('The passwords you entered don’t match.');
    if (!fullName || !phone || !company) return setError('A few details are still missing — fill in every field.');
    if (!tosChecked) return setError('Please review and agree to the Terms of Service to continue.');

    setLoading(true);
    try {
      await store.auth.register(email.trim(), password, {
        fullName: fullName.trim(),
        phone: phone.trim(),
        company: company.trim(),
      });

      const queryParams = qs.parse(location.search);
      submitHubSpot({
        email,
        phone,
        name: fullName,
        company,
        website_url: websiteUrl,
        get_started_with_capture_: true,
        utm: queryParams.utm || '',
      });

      const { partner = '', instance } = store.initQueryParams;
      if (partner.toLowerCase() === 'wix' && instance) {
        store.integrations.WiX.linkAccounts(instance);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
    return undefined;
  };

  return (
    <AuthShell
      eyebrow="Get started"
      headline={(<>Stop <em>losing</em> leads.</>)}
      lede="Setup takes under a minute. Capture, recover, and convert visitors that would otherwise be lost — starting with your next session."
    >
      <form onSubmit={onSubmit} autoComplete="on" noValidate>
        <Field
          label="Work email"
          name="email"
          type="email"
          value={email}
          onChange={setField}
          autoComplete="email"
          placeholder="you@company.com"
          icon={MailIcon}
        />

        <div className="grid grid-cols-2 gap-3">
          <Field
            label="Password"
            name="password"
            type="password"
            value={password}
            onChange={setField}
            autoComplete="new-password"
            placeholder="Min. 8 characters"
            icon={LockIcon}
            reveal
          />
          <Field
            label="Confirm"
            name="passwordConfirm"
            type="password"
            value={passwordConfirm}
            onChange={setField}
            autoComplete="new-password"
            placeholder="Repeat password"
            icon={LockIcon}
            reveal
          />
        </div>

        <Field
          label="Full name"
          name="fullName"
          value={fullName}
          onChange={setField}
          autoComplete="name"
          placeholder="Jane Lee"
          icon={UserIcon}
        />

        <div className="grid grid-cols-2 gap-3">
          <Field
            label="Phone"
            name="phone"
            value={phone}
            onChange={setField}
            autoComplete="tel"
            placeholder="(555) 123-4567"
            icon={PhoneIcon}
          />
          <Field
            label="Company"
            name="company"
            value={company}
            onChange={setField}
            autoComplete="organization"
            placeholder="Acme, Inc."
            icon={BuildingIcon}
          />
        </div>

        <Field
          label="Website URL"
          name="websiteUrl"
          value={websiteUrl}
          onChange={setField}
          autoComplete="url"
          placeholder="https://acme.com"
          icon={GlobeIcon}
        />

        <label className="flex items-start gap-[10px] cursor-pointer text-[13.5px] text-mov-ink-soft select-none mt-2 mb-5">
          <input type="checkbox" checked={tosChecked} onChange={toggleTos} className="check mt-[2px]" />
          <span>
            I have read and agree to the{' '}
            <button
              type="button"
              onClick={() => setTosOpen(true)}
              className="bg-transparent border-0 p-0 text-mov-ink font-medium underline underline-offset-[3px] decoration-mov-line-strong hover:decoration-mov-green cursor-pointer"
            >
              Terms of Service
            </button>
            .
          </span>
        </label>

        {error && (
          <p className="text-[13px] mb-4 text-accent-red flex items-baseline gap-2">
            <span className="mono uppercase text-[10.5px]" style={{ letterSpacing: '0.14em' }}>Err</span>
            <span>{error}</span>
          </p>
        )}

        <PrimaryButton loading={loading}>Create account</PrimaryButton>

        <p className="mt-7 text-center text-mov-ink-soft text-[13.5px]">
          Already have an account?{' '}
          <Link
            to="/login"
            className="text-mov-ink font-medium no-underline border-b border-mov-line-strong pb-px hover:border-mov-green hover:text-mov-green-ink"
          >
            Sign in
          </Link>
        </p>
      </form>

      <TermsModal
        open={tosOpen}
        onClose={() => setTosOpen(false)}
        onAgree={() => { if (!tosChecked) toggleTos(); setTosOpen(false); }}
      />
    </AuthShell>
  );
};

export default withRouter(inject('store')(observer(RegisterPage)));
